import { CoachMark } from '@/components'
import { backtestCoachStore, useBacktestCoach } from '../backtestCoach'

/**
 * First-backtest coach (see backtestCoach.ts for the state machine): one spotlight on the
 * results badge in chat. Non-blocking — the app stays fully usable underneath.
 */

const CARD_COPY =
  "Your backtest is complete — here's where you'll see the results. From here you can run the optimizer or open the full report."

interface BacktestCoachProps {
  isMobile: boolean
  /** The ack on mobile closes the chat sheet, so the user lands back on the chart. */
  onCloseMobileChat: () => void
}

export default function BacktestCoach({ isMobile, onCloseMobileChat }: BacktestCoachProps) {
  const { step, msgId } = useBacktestCoach()

  if (step === 'card' && msgId) {
    const ack = () => {
      if (isMobile) onCloseMobileChat()
      backtestCoachStore.next()
    }
    return (
      <CoachMark
        targetSelector={`[data-coach="backtest-card"][data-msg-id="${msgId}"]`}
        placement={isMobile ? 'top' : 'left'}
        copy={CARD_COPY}
        primaryLabel="Got it"
        onPrimary={ack}
        onDismiss={ack}
      />
    )
  }

  return null
}
